import React from 'react'
import { getTZOffset } from 'web/src/shared/Utils'
import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useAccountQuery = () => {
  return useGenericRequestHandler({
    route: 'v1/c/account',
    method: 'POST',
    options: {
      json: {
        TZOffset: getTZOffset()
      }
    }
  })
}
